export function parseDuration(duration: string): number {
  // Сначала проверяем полный ISO 8601 формат с неделями, днями, часами и минутами
  // Поддерживаем форматы: P1WT5H15M, P5DT5H15M, PT45H15M, и т.д.
  const iso8601Match = duration.match(/^P(?:(\d+)W)?(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?)?$/);

  if (iso8601Match) {
    // Проверяем что хотя бы одно значение есть
    if (iso8601Match[1] || iso8601Match[2] || iso8601Match[3] || iso8601Match[4]) {
      const weeks = parseInt(iso8601Match[1] || '0', 10);
      const days = parseInt(iso8601Match[2] || '0', 10);
      const hours = parseInt(iso8601Match[3] || '0', 10);
      const minutes = parseInt(iso8601Match[4] || '0', 10);

      // 1 неделя = 5 рабочих дней, 1 рабочий день = 8 часов
      return weeks * 5 * 8 * 60 + days * 8 * 60 + hours * 60 + minutes;
    }
  }

  // Проверяем русский формат с неделями (1н 3д 2ч 30м)
  const russianMatch = duration.match(
    /(?:(\d+)\s*н)?(?:\s*(\d+)\s*д)?(?:\s*(\d+)\s*ч)?(?:\s*(\d+)\s*м)?/,
  );

  if (russianMatch && (russianMatch[1] || russianMatch[2] || russianMatch[3] || russianMatch[4])) {
    const weeks = parseInt(russianMatch[1] || '0', 10);
    const days = parseInt(russianMatch[2] || '0', 10);
    const hours = parseInt(russianMatch[3] || '0', 10);
    const minutes = parseInt(russianMatch[4] || '0', 10);

    // 1 неделя = 5 рабочих дней, 1 рабочий день = 8 часов
    return weeks * 5 * 8 * 60 + days * 8 * 60 + hours * 60 + minutes;
  }

  // Проверяем формат с днями (1d1h, 2d30m, 1d, 2h, etc.)
  const dayHourMinuteMatch = duration.match(/(?:(\d+)d)?(?:(\d+)h)?(?:(\d+)m)?/);

  if (
    dayHourMinuteMatch &&
    (dayHourMinuteMatch[1] || dayHourMinuteMatch[2] || dayHourMinuteMatch[3])
  ) {
    const days = parseInt(dayHourMinuteMatch[1] || '0', 10);
    const hours = parseInt(dayHourMinuteMatch[2] || '0', 10);
    const minutes = parseInt(dayHourMinuteMatch[3] || '0', 10);

    // 1 рабочий день = 8 часов
    return days * 8 * 60 + hours * 60 + minutes;
  }

  return 0;
}
